import { createSelector } from "reselect";

/**
 * selector to determine if patient overview medication is enabled
 */
export const patientOverviewMedicationEnabledSelector = createSelector(
  () => false
);
